module.exports = __webpack_public_path__ + "static/media/conveyor-belt.7fb79af1.svg";